import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '@services/auth.service';

type ClaimRequirement = (claims: unknown) => boolean;

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.loggedIn()) {
    return router.createUrlTree(['/auth/login'], {
      queryParams: { returnUrl: state.url },
    });
  }

  const claimRequirement = route.data['claimReq'];
  if (claimRequirement === undefined) {
    return true;
  }

  if (
    typeof claimRequirement === 'function' &&
    (claimRequirement as ClaimRequirement)(authService.getClaims())
  ) {
    return true;
  }

  return router.createUrlTree(['/forbidden']);
};
